export enum ContractType {
  ERC20 = "ERC20",
  Pool = "Pool",
  Router = "Router",
}
